var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCustomize(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 16v-4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5 12h6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10 19c0-1.5 1-2 2-2.5s2-1 2-2.5-1-2-2-2.5-2-1-2-2.5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCustomize);
export default __webpack_public_path__ + "static/media/icon-customize.8e6dafda1f91e224ee16e545ff63db77.svg";
export { ForwardRef as ReactComponent };